export default __webpack_public_path__ + "static/media/profile-card-component-thumbnail.16f4c4dc.png";